export function exportcsv(csvContent, filename) {
  // Creating a Blob for having a csv file format
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8,' })
  const objUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', objUrl)
  link.setAttribute('download', `${filename}.csv`)
  link.click()
}
